var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketCap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 41,
    fill: "#FF7040",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0345 55.5455H43.2611C44.1727 55.5455 44.9116 54.4745 44.9116 53.1532V19.3925C44.9116 18.0711 44.1726 17 43.2611 17H38.0345C37.1229 17 36.384 18.0711 36.384 19.3925V53.1532C36.384 54.4745 37.1228 55.5455 38.0345 55.5455ZM21.2438 55.5455H26.4704C27.382 55.5455 28.1209 54.8129 28.1209 53.9092V30.8182C28.1209 29.9144 27.3819 29.1819 26.4704 29.1819H21.2438C20.3321 29.1819 19.5933 29.9145 19.5933 30.8182V53.9091C19.5931 54.8129 20.3321 55.5455 21.2438 55.5455ZM60.0518 55.5455H54.8252C53.9135 55.5455 53.1745 54.5502 53.1746 53.3223V21.9505C53.1746 20.7226 53.9135 19.7274 54.8252 19.7274H60.0518C60.9633 19.7274 61.7023 20.7226 61.7023 21.9505V53.3223C61.7023 54.5504 60.9634 55.5455 60.0518 55.5455Z",
    fill: "#FF7040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.5 59.5454C66.3284 59.5454 67 60.217 67 61.0454C67 61.8738 66.3284 62.5454 65.5 62.5454H15.5C14.6716 62.5454 14 61.8738 14 61.0454C14 60.217 14.6716 59.5454 15.5 59.5454H65.5Z",
    fill: "#FF7040",
    stroke: "#FF7040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketCap);
export default __webpack_public_path__ + "static/media/marketCap.a4b930df53a95c3f0e7e2865666c70b6.svg";
export { ForwardRef as ReactComponent };